import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientListEntity } from './client-list.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Index('idx_client_list_role_unique', ['clientListId', 'roleId'], {
	unique: true,
})
@Index('idx_client_list_role_list', ['clientListId'])
@Index('idx_client_list_role_role', ['roleId'])
@Entity('client_list_role')
export class ClientListRoleEntity extends BaseEntity {
	@Column('int', { name: '_fk_client_list__id', unsigned: true })
	public clientListId!: number;

	@Column('int', { name: '_fk_rbac_role__id', unsigned: true })
	public roleId!: number;

	@ManyToOne(() => ClientListEntity, (list) => list.sharedRoles, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client_list__id', referencedColumnName: 'id' }])
	public clientList!: ClientListEntity;

	@ManyToOne(() => RbacRoleEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_rbac_role__id', referencedColumnName: 'id' }])
	public role!: RbacRoleEntity;
}
